// Formats requirements/responsibilities as newline-separated "• " bullets (matches job_scraper / JobDetails).

function stripBulletPrefix(line) {
  let s = (line || "").trim();
  while (/^[•\-*]\s*/.test(s)) {
    s = s.replace(/^[•\-*]\s*/, "").trim();
  }
  const numbered = s.match(/^\d+\.\s+(.*)$/);
  if (numbered) {
    s = numbered[1].trim();
  }
  return s;
}

export function parseDescriptionItems(text) {
  const trimmed = (text || "").trim();
  if (!trimmed) return [];

  if (trimmed.includes("\n")) {
    const items = trimmed
      .split("\n")
      .map(stripBulletPrefix)
      .filter(Boolean);
    if (items.length) return items;
  }

  if (trimmed.includes("•")) {
    const items = trimmed
      .split(/\s*•\s*/)
      .map(stripBulletPrefix)
      .filter(Boolean);
    if (items.length > 1) return items;
  }

  if (trimmed.includes(";")) {
    const items = trimmed
      .split(";")
      .map(stripBulletPrefix)
      .filter(Boolean);
    if (items.length > 1) return items;
  }

  const sentences = trimmed.split(/\.\s+(?=[A-Z(])/);
  if (sentences.length > 1) {
    return sentences
      .map((part, i) => {
        let s = stripBulletPrefix(part);
        if (!s) return "";
        if (i < sentences.length - 1 && !s.endsWith(".")) s += ".";
        return s;
      })
      .filter(Boolean);
  }

  return [stripBulletPrefix(trimmed)].filter(Boolean);
}

export function normalizeBulletDescription(text) {
  const items = parseDescriptionItems(text);
  if (!items.length) return text || "";
  return items.map((item) => `• ${item}`).join("\n");
}
